import { useQuery } from "@tanstack/react-query"

export const createCustomField = async (data) => {
    return DjangIO.app.grassroots.models.CustomTag.objects.create(data).POST()
}

export const updateCustomQuestion = async (id, data) => {
    return DjangIO.app.grassroots.models.CustomTag.objects.get(id).update(data).PATCH()
}

export const loadCustomQuestion = async (id) => {
    return DjangIO.app.grassroots.models.CustomTag.objects.get(id).GET()
}

export const useCustomQuestion = (id: number) => {
    return useQuery<QuorumModel["CustomTag"]>({
        queryKey: ["custom-question", id],
        queryFn: () => loadCustomQuestion(id),
        enabled: Boolean(id),
        staleTime: Infinity,
    })
}

export const archiveCustomQuestion = async (id) => {
    return DjangIO.app.grassroots.models.CustomTag.objects.get(id).update({ archived: true }).PATCH()
}
